import Vue from "vue";
import App from "./App.vue";
import Router from "vue-router";
import router from "./router";
import axios from "./base/axios";
import echarts from "echarts";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import "./base/index.css";
import "./base/index.scss";
import store from "./store/store";
import { utilMethod } from "./base/util.js";
import i18n from './i18n/i18n';
let util = new utilMethod();
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.util = util;
Vue.prototype.$echarts = echarts;
Vue.use(Router);
Vue.use(ElementUI,{
  i18n:(key,value) =>i18n.t(key,value)
});
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
router.beforeEach((to, from, next) => {
  if (to.path == "/price") {
    let token = sessionStorage.getItem("token");
    if (token) {
      next();
    } else {
      next(
        {
        path: "/login",
        query:{
          type:1
        }
      }
      );
    }
  }else {
    next();
  }
});
Vue.filter("ellipsisprot", function(value) {
  if (!value) return "";
  if (value.length > 35) {
    return value.slice(0, 35) + "...";
  }
  return value;
});
// project-产品特色
Vue.filter('ellipsisports',function(value) {
  if(!value) return "";
  if(value.length >20) {
    return value.slice(0,20) +'...';
  }
  return value;
})
// project-标题
Vue.filter('ellipsis',function(value) {
  if(!value) return "";
  if(value.length >130) {
    return value.slice(0,130) +'...';
  }
  return value;
})
// project-案例
Vue.filter('caseellipsis',function(value) {
  if(!value) return "";
  if(value.length>80) {
    return value.slice(0,80) +'...';
  }
  return value;
})
Vue.filter('caseellipsisd',function(value) {
  if(!value) return "";
  if(value.length>180) {
    return value.slice(0,180) +'...';
  }
  return value;
})
// about
Vue.filter('aboutellipsis',function(value) {
  if(!value) return "";
  if(value.length>68) {
    return value.slice(0,68) +'...';
  }
  return value;
})
Vue.filter('indenllipsis',function(value) {
  if(!value) return "";
  if(value.length>22) {
    return value.slice(0,22) +'...';
  }
  return value;
})
Vue.filter('popellipsis',function(value) {
  if(!value) return "";
  if(value.length>10) {
    return value.slice(0,10) +'...';
  }
  return value;
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
